import { Box, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import api from '../../../alive-academics/service/api'

const MaintenanceMessageBlock = () => {

    const [underMaintenance, setUnderMaintenance] = useState( false )

    const { layout } = useTheme()

    useEffect( () => {
        const abortController = new AbortController()

        const fetchSettings = async () => {

            try {
                const { data: { data: settings } } = await api.getSettings( { filter: 'foruse' }, { signal: abortController.signal } )
                const maintenanceMessageShowSetting = settings.find( setting => setting.setting_key === 'show_alive_maintenance_message' )
                if ( maintenanceMessageShowSetting ) {
                    setUnderMaintenance( maintenanceMessageShowSetting.value === 'true' )
                } else {
                    setUnderMaintenance( false )
                }

            } catch ( err ) {
                console.log( err )
            }
        }
        fetchSettings()

        return () => {
            if ( abortController )
                abortController.abort()
        }
    }, [] )

    if ( !underMaintenance )
        return null

    return (
        <Box sx={{ bgcolor: "primary.main", px: 2, py: 1, borderRadius: `0 0 ${layout.borderRadius * 4}px ${layout.borderRadius * 4}px` }}>
            <Typography sx={{ textAlign: "center", color: "primary.contrastText" }} >Alive is under maintenance</Typography>
        </Box>
    )
}

export default MaintenanceMessageBlock
